import { render, staticRenderFns } from "./DisclaimerButton.vue?vue&type=template&id=68b377c2"
import script from "./DisclaimerButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./DisclaimerButton.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DisclaimerButton.vue?vue&type=style&index=0&id=68b377c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports